import styled from "styled-components"
import { useDispatch } from "react-redux"
import { setHiddenAracColumnList, updateBolgedekiTekliflerItemPrice } from "../../../features/bolgedekiTekliflerim/bolgedekiTekliflerimSlice"
import { RxDoubleArrowLeft, RxDoubleArrowRight } from "react-icons/rx";
import { useState } from "react";
import { useSelector } from "react-redux";

const Container = styled.div`

    margin-left: 550px;
    overflow-x: auto;
    height: fit-content;
    padding-top: 50px;
    width: 100%;

    &::-webkit-scrollbar {
        height: 8px;
        }
        &::-webkit-scrollbar-thumb {
            background-color: ${({theme})=> theme.secondaryTextColor};
            border-radius: 10px;
        }
        &::-webkit-scrollbar-track {
            background-color: transparent;
        }

table{
    border-collapse: collapse;
    
}
thead{
    width: 100%;
    background-color: var(--color-main);

    tr{

        .title-th{
            color: #fff;
            height: 37px;
            border: 1px solid #fff;
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-lg);
            text-align: center;
            position: relative;

            /* &:first-child{
                border-left: 1px solid var(--color-main);
            } */

            &:last-child{
                border-right: 1px solid var(--color-main);
            }

            .arr-icon{
                font-size: 1.2rem;
                position: absolute;
                left: 10px;
                cursor: pointer;
            }
        }

        .close-title-th{
            border: 1px solid #fff;


            .arr-icon{
                font-size: 1.2rem;
                cursor: pointer;
                color: #fff;
            }
        }
    }
}

tbody{

    tr{
        .data-td{
            border: 1px solid ${({theme}) => theme.mainTextColor};
            text-align: start;
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-lg);
            padding: 10px 15px;
            padding: 0;
            height: 35px;

            input{
                width: 100px;
                text-align: center;
            }
        }

        .data-td-empty{
            border: 1px solid ${({theme}) => theme.mainTextColor};
            background-color: ${({theme}) => theme.secondaryBgColor};
            border-top: none;
        }
    }

}
    
`

const HoverItemContainer = styled.div`
    
    width: max-content;
    height: 30px;
    border-radius: 10px 10px 10px 0;
    color: ${({theme}) => theme.mainTextColor};
    font-size: var(--font-size-sm);
    font-weight: var(--font-weight-lg);
    position: absolute;
    top: -43px;
    left: 10px;
    z-index: 20;
    background-color: ${({theme}) => theme.secondaryBgColor};
    padding: 5px 40px;
    display: flex;
    justify-content: center;
    align-items: center;


`

const SVG = styled.svg`
    position: absolute;
    top: -18px;
    left: 10px;
    width: 20px;
    height: 20px;
`

const HoverItem = ({title}) => {

    return (
        <HoverItemContainer>
            {title}
        </HoverItemContainer>
    )
}


const titles = [
    {
        id: 4,
        text: "Tır",
        colspan: 3,
        innerRow: [
            {
                id: 1,
                text: "Hafif Tonaj",
                colspan: 1,
            },
            {
                id: 2,
                text: "Normal Tonaj",
                colspan: 1,
            },
            {
                id: 3,
                text: "Ağır Tonaj",
                colspan: 1,
            }
        ]
    },
    {
        id: 3,
        text: "Kırkayak",
        colspan: 3,
        innerRow: [
            {
                id: 1,
                text: "Hafif Tonaj",
                colspan: 1,
            },
            {
                id: 2,
                text: "Normal Tonaj",
                colspan: 1,
            },
            {
                id: 3,
                text: "Ağır Tonaj",
                colspan: 1,
            }
        ]
    },
    {
        id: 5,
        text: "10 Teker Kamyon",
        colspan: 3,
        innerRow: [
            {
                id: 1,
                text: "Hafif Tonaj",
                colspan: 1,
            },
            {
                id: 2,
                text: "Normal Tonaj",
                colspan: 1,
            },
            {
                id: 3,
                text: "Ağır Tonaj",
                colspan: 1,
            }
        ]
    },
    {
        id: 6,
        text: "6 Teker Kamyon",
        colspan: 3,
        innerRow: [
            {
                id: 1,
                text: "Hafif Tonaj",
                colspan: 1,
            },
            {
                id: 2,
                text: "Normal Tonaj",
                colspan: 1,
            },
            {
                id: 3,
                text: "Ağır Tonaj",
                colspan: 1,
            }
        ]
    },
    {
        id: 7,
        text: "Kamyon Römork",
        colspan: 3,
        innerRow: [
            {
                id: 1,
                text: "Hafif Tonaj",
                colspan: 1,
            },
            {
                id: 2,
                text: "Normal Tonaj",
                colspan: 1,
            },
            {
                id: 3,
                text: "Ağır Tonaj",
                colspan: 1,
            }
        ]
    },
    {
        id: 1,
        text: "Kamyonet",
        colspan: 3,
        innerRow: [
            {
                id: 1,
                text: "Hafif Tonaj",
                colspan: 1,
            },
            {
                id: 2,
                text: "Normal Tonaj",
                colspan: 1,
            },
            {
                id: 3,
                text: "Ağır Tonaj",
                colspan: 1,
            }
        ]
    },
]

const BolgedekiTekliflerimTable = ({bolgedekiTeklifler, hiddenAracColumnList, isSettingsOpen}) => {

    const dispatch = useDispatch()

    const [hoveredTitle, setHoveredTitle] = useState(null)

    const {theme} = useSelector(state => state.layout)


  return (
    <Container>
        <table>
        <thead>
            <tr>
                {
                    titles.map((item) => {
                        return !hiddenAracColumnList.includes(item.id) ? (
                            <th className="title-th" colSpan={item.colspan} id={item.id} key={item?.id}>
                                <div style={{height: "36px", display: "flex", justifyContent: "center", alignItems: "center"}}>
                                    <RxDoubleArrowLeft className="arr-icon" onClick={() => dispatch(setHiddenAracColumnList(item.id))}/>{item.text}
                                </div>
                            </th>
                        )
                        : 
                        <th className="close-title-th" key={item?.id} style={{backgroundColor: "var(#E85446)", position: "relative", cursor: "pointer"}} onMouseEnter={() => setHoveredTitle(item.id)} onClick={() => dispatch(setHiddenAracColumnList(item.id))} onMouseLeave={() => setHoveredTitle(null)}>
                            {
                                hoveredTitle === item.id &&
                                <>
                                    <HoverItem title={item.text}/>
                                    <SVG width="19" height="15" viewBox="0 0 19 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M0.00153421 15L-5.76111e-07 3.25789e-07L19 1.98682e-06L0.00153421 15Z" fill={theme === "dark" ? "#4D4D4D" : "#f0eded"}/>
                                    </SVG>
                                </>
                            }
                            

                            <div style={{height: "36px", display: "flex", justifyContent:"center", alignItems: "center", width: "30px"}}>
                                <RxDoubleArrowRight className="arr-icon"/>
                            </div>
                        </th>
                    })
                }
            </tr>
            <tr>
            {
                titles.map((item) => {
                    if(!hiddenAracColumnList.includes(item.id)){
                        return item.innerRow.map((innerItem)=> (
                            <th className="title-th" style={{ width: 'min-content' }} colSpan={innerItem.colspan}>{innerItem.text}</th>
                        ))
                    }
                    else{
                        return <th className="close-title-th" style={{backgroundColor: "var(#E85446)"}}></th>
                    }
                })
            }   
            </tr>
        </thead>
        <tbody>
            {
                bolgedekiTeklifler?.map((item, i) => (
                <tr>
                    {
                        item.transportOffers?.map((truckItem) => {

                            return !hiddenAracColumnList.includes(truckItem.aracTuruId) ? (
                                <>
                                    <td className="data-td">
                                        <input type="text" value={truckItem.lightWeightPrice === 0 ? "" : truckItem.lightWeightPrice} onChange={(e) => dispatch(updateBolgedekiTekliflerItemPrice({key: "lightWeightPrice", value: parseInt(e.target.value.replace(/[^0-9]/g, ''))|| 0,   itemId: item.id, aracTuruId: truckItem.aracTuruId}))} />
                                    </td>
                                    <td className="data-td">
                                        <input type="text" value={truckItem.normalWeightPrice === 0 ? "" : truckItem.normalWeightPrice} onChange={(e) => dispatch(updateBolgedekiTekliflerItemPrice({key: "normalWeightPrice", value: parseInt(e.target.value.replace(/[^0-9]/g, ''))|| 0, itemId: item.id, aracTuruId: truckItem.aracTuruId}))}/>
                                    </td>
                                    <td className="data-td">
                                        <input type="text" value={truckItem.heavyWeightPrice === 0 ? "" : truckItem.heavyWeightPrice} onChange={(e) => dispatch(updateBolgedekiTekliflerItemPrice({key: "heavyWeightPrice", value: parseInt(e.target.value.replace(/[^0-9]/g, ''))|| 0, itemId: item.id, aracTuruId: truckItem.aracTuruId}))}/>
                                    </td>
                                </>
                            )
                            : 
                            <>
                                <td className="data-td-empty"></td>
                            </>
                        })
                    }
                </tr>
                ))
            }
        </tbody>
        </table>
    </Container>
  )
}

export default BolgedekiTekliflerimTable